<template>
    <div class="displaySection shorten">
        <div v-if="textDisplay === 'full'" class="fullText">
            <slot></slot>
        </div>

        <div v-else-if="textDisplay === 'left'" class="leftText">
            <slot></slot>
            <div class="transparent"></div>
        </div>

        <div v-else class="rightText">
            <div class="transparent"></div>
            <slot></slot>
        </div>
    </div>
</template>

<script>

    export default {
        name: "DisplaySection",
        props:[
            'textDisplay'
        ]
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/_variables.scss";

    .displaySection{
        display: grid;
        grid-template-columns: 50vw 50vw;
        min-height: 100vh;
        max-height: 100vh;

        @media screen and (max-width: $tabletWidth){
            min-height: initial;
            grid-template-rows: 55vh;
            grid-template-columns: inherit;

            .leftText{
            }
            .rightText{
            }
            .fullText{
                display:none;
            }
        }

        @media screen and (max-width: $largeMobile){
            &:first-child{
                margin-top: 0;
            }
            &:last-child{
            }
            grid-template-rows: 100vh;

            .leftText,
            .rightText{
                grid-row: 1/2;
            }
        }

        @media screen and (max-width: $mediumMobile){
        }
    }

    .leftText{
        background: $gumGreen;
        grid-column:1/2;
        > .transparent{
            grid-column: 2/3;
        }
    }

    .rightText{
        background: $gumGreen;
        grid-column: 2/3;
        > .transparent{
            grid-column: 1/2;
        }
    }

    .fullText{
        background: $gumGreen;
        grid-column:1 / span 4;
        // overflow: hidden;
        max-height: 100vh;
        max-width: 100vw;
    }

    .transparent{
        background: transparent;
    }

</style>
